import { useEffect, useState } from "react";
import DesignationList from "../../components/AdminComponents/PagesComponents/Designation/DesignationList";
import AddDesignationModal from "../../components/AdminComponents/PagesComponents/Designation/AddDesignationModal";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";
import { addDesignation, getAllDesignations, toggleDesignationStatus, updateDesignation } from "../../services/AdminServices";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";

const AdminDesignationPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [designations, setDesignations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    designation: null,
  });

  const [messageModal, setMessageModal] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  const showSuccess = (msg) => {
    setMessageModal({
      open: true,
      type: "success",
      title: "Success",
      message: msg,
    });
  };

  const showError = (msg) => {
    setMessageModal({
      open: true,
      type: "error",
      title: "Error",
      message: msg,
    });
  };

  const handleToggleRequest = (designation) => {
    setConfirmModal({ open: true, designation });
  };

  const handleConfirmToggle = async () => {
    try {
      await toggleDesignationStatus(confirmModal.designation.id);
      await loadDesignations();
      showSuccess(confirmModal.designation.active ? "Designation deactivated successfully" : "Designation activated successfully");
    } catch (err) {
      showError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setConfirmModal({ open: false, designation: null });
    }
  };


  const loadDesignations = async () => {
    try {
      setLoading(true);
      const res = await getAllDesignations();
      if (res.success) {
        setDesignations(res.data);
      }
    } catch (err) {
      console.error(err?.response?.data?.message);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDesignations();
  }, []);

  const handleSave = async (formData) => {
    try {
      let res;
      if (editData) {
        res = await updateDesignation(editData.id, formData);
      } else {
        res = await addDesignation(formData);
      }

      if (res.success) {
        await loadDesignations();
        setOpenModal(false);
        setEditData(null);
        showSuccess(res.message);
      }
    } catch (err) {
      showError(err?.response?.data?.message || "Something went wrong");
    }
  };



  return (
    <div className="p-4 admin-card-box space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="admin-heading text-blue">Designation Master</h2>
        <button
          className="btnAdd"
          onClick={() => {
            setEditData(null);
            setOpenModal(true);
          }}
        >
          + Add Designation
        </button>
      </div>

      <DesignationList
        data={designations}
        loading={loading}
        onEdit={(d) => {
          setEditData(d);
          setOpenModal(true);
        }}
        onToggle={handleToggleRequest}
      />

      <AddDesignationModal
        open={openModal}
        editData={editData}
        onClose={() => setOpenModal(false)}
        onSave={handleSave}
      />

      <ConfirmActionModal
        open={confirmModal.open}
        title={
          confirmModal.designation?.active
            ? "Deactivate Designation"
            : "Activate Designation"
        }
        message={
          confirmModal.designation?.active
            ? "Do you really want to deactivate this designation?"
            : "Do you want to activate this designation again?"
        }
        confirmText={
          confirmModal.designation?.active ? "DEACTIVATE" : "ACTIVATE"
        }
        onConfirm={handleConfirmToggle}
        onClose={() =>
          setConfirmModal({ open: false, designation: null })
        }
      />

      <MessageModal
        open={messageModal.open}
        type={messageModal.type}
        title={messageModal.title}
        message={messageModal.message}
        onClose={() =>
          setMessageModal({ ...messageModal, open: false })
        }
      />
    </div>
  );
};

export default AdminDesignationPage;
